import { gsap } from "gsap";

export function modal() {
    const animationDuration = 0.4;
    const fadeUpDistance = 28;
    const ease = "power2.out";
    let currentTimeline = null;

    const btns = document.querySelectorAll('.modal-toggle');
    
    btns.forEach((btn) => {
        const trigger = btn.dataset.openModalId;
        const wrapper = btn.closest('.modal-group');
        const modal = wrapper ? wrapper.querySelector(`[data-modal-id="${trigger}"]`) : null;
        if (modal !== null) {
            // Position function
            const updatePosition = () => {
                const btnRect = btn.getBoundingClientRect();
                const wrapperRect = wrapper.getBoundingClientRect();
                const modalWidth = modal.offsetWidth;
                const modalHeight = modal.offsetHeight;
                
                // Calculate position relative to wrapper
                const btnTop = btnRect.top - wrapperRect.top;
                const btnLeft = btnRect.left - wrapperRect.left;
                const btnRight = btnRect.right - wrapperRect.left;
                
                // Check if modal overflows viewport on the right
                const modalRightEdge = btnRect.right + modalWidth;
                
                if (modalRightEdge > window.innerWidth) {
                    // Position modal on the left of the button
                    modal.style.left = `${btnLeft - modalWidth}px`;
                    modal.style.right = 'auto';
                } else {
                    // Position modal on the right of the button
                    modal.style.left = `${btnRight}px`;
                    modal.style.right = 'auto';
                }
                
                // Position modal vertically aligned with button
                modal.style.top = `${btnTop}px`;
            };
            
            // Update position on resize
            window.addEventListener('resize', updatePosition);

            // Toggle modal
            const tl = gsap.timeline({ paused: true });
            tl.to(modal, {
                display: "block",
                duration: 0.00001,
                onComplete: () => {
                    // Update modal position before opening
                    updatePosition();
                },
            })
            .fromTo(modal, {
                opacity: 0,
                y: fadeUpDistance,
            }, {
                opacity: 1,
                y: 0,
                duration: animationDuration,
                ease: ease,
                onStart: () => {
                    // Update modal position before opening
                    updatePosition();
                },
            })
            .reverse();

            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                
                // Close previous modal and remove its active class
                if (currentTimeline && currentTimeline !== tl && !currentTimeline.reversed()) {
                    const previousBtn = document.querySelector('.modal-toggle.active');
                    if (previousBtn) {
                        previousBtn.classList.remove('active');
                    }
                    currentTimeline.timeScale(2).reverse();
                }
                
                // Toggle active class
                if (tl.reversed()) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
                
                // Toggle current modal
                tl.reversed(!tl.reversed());
                currentTimeline = tl.reversed() ? null : tl.timeScale(1);
            });

            modal.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    });

    // Close modal on clicking outside
    document.addEventListener('click', () => {
        if (currentTimeline && !currentTimeline.reversed()) {
            const activeBtn = document.querySelector('.modal-toggle.active');
            if (activeBtn) {
                activeBtn.classList.remove('active');
            }
            currentTimeline.reverse();
            currentTimeline = null;
        }
    });
}